export default function Python_IfElse() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_If...Else</h1>
      <p>Content for Python_If...Else goes here.</p>
    </div>
  );
}